<template>
	<div>
		<div class="succes_dec">
			<img :src="imgPath+'duiahuncg.png'" alt="">
			<h4>支付成功</h4>
			<p>您可以订单列表里查看详情</p>
		</div>
		<div class="my_btn">

			<p @click="goHome">返回首页</p>
			<p @click="checkOrder">查看订单</p>
		</div>
	</div>
</template>
<script>
	export default{
		name:'success',
		data(){
			return {
				goods_type:0,
			}
		},
		mount(){
			this.goods_type = this.$route.query.goods_type;
		},
		methods:{
			goHome(){
				this.$router.push({path:'/'})
			},
			checkOrder(){
				let psyGoodsType = this.goods_type==1? '20':'0';
				this.$router.push({path:'/order',query:{type:psyGoodsType}})
			}
		}
	}
</script>
<style scoped>
	.succes_dec{
		text-align: center;
		font-size: 0.56rem;
		padding-top: 3.2rem;
	}
	.succes_dec img{
		width: 2.8rem;
		height: 2.8rem;
		display: block;
		margin: 0 auto 0.6rem;
	}
	.succes_dec h4{
		font-size:0.72rem;
		font-weight:bold;
		margin-bottom: 0.58rem;
	}
	.my_btn {
		margin-top: 1.4rem;
		display: flex;
		justify-content: space-around;
	}
	.my_btn p {
		width:6.4rem;
		height:2rem;
		line-height: 2rem;
		border:2px solid rgba(253,62,62,1);
		border-radius:0.2rem;
		font-size: 0.6rem;
		color: #FD3E3E;
		text-align: center;
	}
	.my_btn p:last-child{
		background: #FD3E3E;
		color: #fff;
	}
</style>
